var _ = require('underscore');
var TableView = require('./../widget/brec-table/table-view/TableView');
var InsuranceEstimationDataBehavior = require('./InsuranceEstimationDataBehavior');
var EstimateItemView = require('./EstimateItemView');
var estimatesListTemplate = require('./estimatesListTemplate.hbs');
var rootUpdateEvents = _.clone(TableView.pagingUpdateEvents);
rootUpdateEvents.push('_tableState:change:patientVecnaId');

/**
 * List Widget for account estimates
 *
 * @class EstimatesListWidget
 * @constructor
 */
module.exports = TableView.extend({
  id: 'estimates-table',
  template: estimatesListTemplate,
  itemView: EstimateItemView,

  behaviors: {
    insuranceEstimations: {
      behavior: InsuranceEstimationDataBehavior,
      alwaysFetch: true,
      updateEvents: rootUpdateEvents,
      ids: function(cache) {
        var view = this.view;
        var thisFetchId = view._startLoading();
        var criteria = view._getInsuranceEstimationCriteria();
        return cache.fetchIdsByCriteria(criteria)
          .then(function(response) {
            return view.consumePartialListResponse(response, thisFetchId);
          })
          .always(function() {
            view._completeLoading(thisFetchId);
          });
      }
    }
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient that owns the bills in this payable bill list.
   *   @param options.model {PaymentDetailsFormModel} the form model to save any payment info to.
   *                                                  This is copied to model automagically by backbone constructor.
   *   @param options.tableState {TableState} the state & event bus used by the make payment widget.
   * @override
   */
  initialize: function(options) {
    this._tableState = options.tableState;
    var insuranceEstimationsDataBehavior = this.getBehavior('insuranceEstimations');
    this.collection = insuranceEstimationsDataBehavior.data.privateCollection;

    this.listenTo(insuranceEstimationsDataBehavior, 'fetched', this._handleFetchResultStatus);
    this.listenTo(this._tableState, 'change:fetchSuccess', this.render);
    this.listenTo(this.collection, 'checkPendingEstimates', this._checkPendingEstimates);
    this.listenTo(this._tableState, 'change:hasPendingEstimates', this.render);
  },

  /**
   * @method _getInsuranceEstimationCriteria
   * @returns {Object} the insurance estimation criteria to pass to the InsuranceEstimationExtService
   * @private
   */
  _getInsuranceEstimationCriteria: function() {
    return {
      patientVecnaId: this._tableState.get('patientVecnaId'),
      pagingAndSorting: this._tableState.getPagingAndSorting()
    };
  },

  /**
   * Handles the result of the data behavior fetch.
   * @method _handleFetchResultStatus
   * @param fetchResult {Object} The fetch result.
   *   @param fetchResult.status {String} 'success' then it was successful, 'failed' then it failed.
   * @private
   */
  _handleFetchResultStatus: function(fetchResult) {
    var fetchSuccess = (fetchResult.status === 'success');
    this._tableState.set('fetchSuccess', fetchSuccess);
  },

  /**
   * Check all the item view to see if there are any pending approval estimated costs.
   * @method _checkInsuranceUpdates
   * @return
   */
  _checkPendingEstimates: function() {
    var hasPendingEstimates =
      _.some(this.getItemViews(), function(itemView) {
        return itemView.hasUnapprovedInsuranceUpdates();
      });
    if (hasPendingEstimates) {
      this._tableState.set('hasPendingEstimates', true);
    }
  }
});
